import React, { useState } from 'react';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import TextWithInputs from 'src/pages/reportUsage/common/textWithInputs/TextWithInputs';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import {
    GridContainer,
    ItemDetailText,
    OnHandText,
    LoTtext,
    UsedBytext,
    UseByDate,
    ItemCardTextContainer,
    EAIcon,
    MdiOptions,
    NTIconContainer,
    NTIcon,
    TIconContainer,
    TIcon,
    MaxExpirytext,
    MaxExpiryDate,
} from './InventoryBody.styled';
import RedAlertIcon from 'src/assets/images/RedAlertIcon.svg';
import { useSelector, useDispatch } from 'react-redux';
import { setInventoryItemsDetails } from '../../redux/actions';
import ClockAlertOutline from 'src/assets/images/ClockAlertOutline.svg';
import { useTranslation } from 'react-i18next';

export default function InventoryBodyDesktop({
    user,
    handleChange,
    index,
    setQuantityValue,
    setItemDetails,
    clrAll,
    //key
}) {
    const dispatch = useDispatch();
    const [quantity, setQuantity] = useState('');
    const [checked, setChecked] = useState(false);
    const [quantityValidation, setQuantityyValidation] = useState(false);
    const checkedItemsBody = useSelector(
        (state) => state.InventoryReturnReducer.checkedItems
    );
    const handleQtyValidation = (e, onHand, isChecked, index, checkedIndex) => {
        setQuantityValue(e.target.value);
        setItemDetails(index, e.target.value, checkedIndex);
        //setValidation(quantityValidation);
    };
    useEffectWithErrorLogging(() => {
        if (Object.prototype.hasOwnProperty.call(user, 'isChecked')) {
            const items = checkedItemsBody
                .filter((item) => item != undefined)
                .map((itemData) => ({
                    ...itemData,
                    flag: itemData.onHand < itemData.used ? true : false,
                }));
            if (user.isChecked) {
                if (!quantity) {
                    checkedItemsBody &&
                        checkedItemsBody.map((item) => {
                            if (item.checkedIndex === index) {
                                setQuantity(item.used);
                                errorValidation(item.used, item.onHand);
                                if (item.onHand < item.used) {
                                    setQuantityyValidation(true);
                                } else {
                                    setQuantityyValidation(false);
                                }
                            }
                        });
                }
                setChecked(true);
                dispatch(setInventoryItemsDetails(items));
            } else {
                setQuantity('');
                setChecked(false);
            }
        }
    }, [user?.isChecked, checkedItemsBody?.isChecked]);

    const loading = useSelector(
        (state) => state.InventoryReturnReducer.loading
    );
    const errorValidation = (value, onHand) => {
        if (value && value > onHand) {
            user.flag = true;
        } else {
            user.flag = false;
        }
    };
    const { t } = useTranslation();
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );

    return (
        <div>
            {loading == false ? (
                <GridContainer
                    container
                    justifyContent={'space-between'}
                    direction="row"
                >
                    <ItemCardTextContainer
                        item
                        xs={1}
                        sm={1}
                        md={1}
                        lg={1}
                        xl={1}
                        mobile={1}
                        key={index}
                        style={{
                            marginRight: '-55px',
                        }}
                    >
                        {/* <input
                        type="checkbox"
                        name={user.lotSerial}
                        checked={user?.isChecked || false}
                        onChange={handleChange}
                        key={index}
                        style={{ height: 20,onChange={handleChange} width: 20,filter:'grayscale(1)' }}
                    /> */}
                        <Checkbox
                            name={user.lotSerial}
                            key={index}
                            value={user.uniqueKey}
                            checked={checked ? checked : user?.isChecked || false}
                            onCheckboxSelectionChange={(e) => handleChange(e, clrAll)}
                            id="consignmentReturn-inventory-InventoryBodyDesktop-lotSerial-checkbox"
                            margin={'2px 0 0 0'}
                            background={'none'}
                            checkboxBorder={'1.5px solid #555555'}
                            alignItemDirection={'center'}
                            hoverEffect={'true'}
                            disableFocusEffect={'true'}
                        />
                    </ItemCardTextContainer>
                    <ItemCardTextContainer
                        item
                        xs={12}
                        sm={3}
                        md={3}
                        lg={4}
                        xl={4}
                        mobile={12}
                        className={'DescGrid'}
                    >
                        <ItemDetailText isDemi>{user.cfn}</ItemDetailText>
                        <ItemDetailText isRegular>
                            {user.materialDesc}
                        </ItemDetailText>
                    </ItemCardTextContainer>
                    {countryISOCode == 'US' && (
                        <ItemCardTextContainer
                            item
                            xs={12}
                            sm={1}
                            md={1}
                            lg={1}
                            xl={2}
                            mobile={12}
                        >
                            <div
                                style={{
                                    display: 'flex',
                                }}
                            >
                                {user.salesOrg === 'S030' ? (
                                    <TIconContainer>
                                        <TIcon>
                                            {t('consignmentReturn.inventory.t')}
                                        </TIcon>
                                    </TIconContainer>
                                ) : (
                                    <NTIconContainer>
                                        <NTIcon>
                                            {t(
                                                'consignmentReturn.inventory.nt'
                                            )}
                                        </NTIcon>
                                    </NTIconContainer>
                                )}
                                <EAIcon>
                                    {' '}
                                    {user?.uom
                                        ? user.uom
                                        : t('consignmentReturn.submit.ea')}
                                </EAIcon>
                            </div>
                        </ItemCardTextContainer>
                    )}
                    <ItemCardTextContainer
                        item
                        xs={12}
                        sm={1}
                        md={1}
                        lg={1}
                        xl={1}
                        mobile={12}
                    >
                        <TextWithInputs
                            name={t('common.qty')}
                            placeholder={'0'}
                            maxLength={2}
                            inputHeight={'40px'}
                            inputWidth={'58px'}
                            alignText={'center'}
                            onkeyUp={(e) => {
                                setQuantity(
                                    e.target.value
                                        ? e.target.value.replace(/[^0-9]+/g, '')
                                        : ''
                                );
                                if (
                                    e.target.value &&
                                    e.target.value.length > 0 &&
                                    e.target.value > user.onHand
                                ) {
                                    setQuantityyValidation(true);
                                } else {
                                    setQuantityyValidation(false);
                                }
                                errorValidation(e.target.value, user.onHand);
                                // e.target.value && e.target.value.length > 0 && e.target.value > user.onHand ? setQuantityValidation(true):setQuantityValidation(false)
                                handleQtyValidation(
                                    e,
                                    user.onHand,
                                    user.isChecked,
                                    index,
                                    user.checkedIndex
                                );
                            }}
                            errorMsg={
                                quantityValidation
                                    ? 'Quantity can\'t exceed On Hand Quantity'
                                    : ''
                            }
                            inputBorder={
                                quantityValidation ? '2px solid #FACFD6' : ''
                            }
                            value={quantity}
                            key={index}
                        />
                    </ItemCardTextContainer>
                    <ItemCardTextContainer
                        item
                        xs={1}
                        sm={1}
                        md={1}
                        lg={1}
                        xl={1}
                        mobile={1}
                    >
                        <OnHandText>{user.onHand}</OnHandText>
                    </ItemCardTextContainer>
                    <ItemCardTextContainer
                        item
                        xs={12}
                        sm={1}
                        md={1}
                        lg={2}
                        xl={2}
                        mobile={12}
                        style={{
                            paddingLeft: '30px',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        <LoTtext>{user.lotSerial}</LoTtext>
                    </ItemCardTextContainer>
                    <ItemCardTextContainer
                        item
                        xs={12}
                        sm={2}
                        md={2}
                        lg={1}
                        xl={1}
                        mobile={12}
                        align={'right'}
                        style={{
                            alignText: 'right',
                        }}
                    >
                        {user.expiryStatus === 'EXPIRED' ? (
                            <div>
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        alignContent: 'center',
                                    }}
                                >
                                    <MdiOptions imageSrc={RedAlertIcon} />
                                    <UsedBytext>
                                        {t(
                                            'consignmentReturn.inventory.expired'
                                        )}
                                    </UsedBytext>
                                </div>
                                <UseByDate>{user.useByDate}</UseByDate>
                            </div>
                        ) : user.expiryStatus === 'minexpiry' ? (
                            // <LoTtext>{user.useByDate}</LoTtext>
                            <div>
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        alignContent: 'center',
                                    }}
                                >
                                    <MdiOptions
                                        imageSrc={ClockAlertOutline}
                                        mr={'4px'}
                                    />
                                    <MaxExpirytext>
                                        {t('consignmentReturn.inventory.useBy')}
                                    </MaxExpirytext>
                                </div>
                                <MaxExpiryDate>{user.useByDate}</MaxExpiryDate>
                            </div>
                        ) : (
                            <LoTtext>{user.useByDate}</LoTtext>
                        )}
                    </ItemCardTextContainer>
                </GridContainer>
            ) : null}
        </div>
    );
}
